import { Avatar } from "@medentic/polaris-react"
import { MultilingualText, ImageDetailType, MediaItem } from "@features/events/types";
import { getLocalizedText } from "@shared/lib";

interface EventsDefaultAvatarProps {
  name: MultilingualText | string;
  singleImage?: ImageDetailType[];
  media?: MediaItem[];
}

export default function EventsDefaultAvatar({ name, singleImage, media }: EventsDefaultAvatarProps) {
  
  // Get the name in current locale or fallback to first available
  const displayName = typeof name === 'string' 
    ? name 
    : getLocalizedText(name);
  
  if (singleImage && singleImage.length > 0) {
    return (
      <img
        src={singleImage[0].src}
        srcSet={singleImage.map((img) => `${img.src} ${img.width}w`).join(", ")}
        sizes="40px"
        alt={displayName}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          objectFit: "cover",
        }}
      />
    );
  }
  
  // Then try to find first image in media
  if (media && media.length > 0) {
    const firstImageMedia = media.find((m) => m.type === "img");
    if (
      firstImageMedia &&
      firstImageMedia.source &&
      Array.isArray(firstImageMedia.source) &&
      firstImageMedia.source.length > 0
    ) {
      return (
        <img
          src={firstImageMedia.source[0].src}
          srcSet={firstImageMedia.source.map((img) => `${img.src} ${img.width}w`).join(", ")}
          sizes="40px"
          alt={displayName}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
      );
    }
  }
  
  // Fallback to Avatar with initials (max 2 first word letters)
  const initials = displayName
    .split(" ")
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
  
  return (
    <Avatar
      size="xl"
      customer={false}
      name={displayName}
      initials={initials}
    />
  );
}

